import { DISMISS_ALERT } from './constants';

export const dismissAlert = () => ({
  type: DISMISS_ALERT,
});
